export default [
  {
    path: '/quest-eternal',
    component: () => import('./views/Index'),
    name: 'quest-eternal',
    redirect: { name: 'quest-eternal-list' },
    children: [
      {
        path: '',
        name: 'quest-eternal-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'content',
        },
      },
      {
        path: 'detail/:eternal_id',
        name: 'quest-eternal-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'content',
        },
      },
    ],
  },
]
